(() => {
  "use strict";

  /**
   * Find the Smartfit widget.
   *
   * @returns {HTMLElement|null}
   */
  const getSmartfitWidget = () => {
    return document.querySelector("#onlinesizing-widget");
  };

  /**
   * Find a Shopify variant by its variant ID.
   *
   * @param {string|number} variantId
   * @returns {Object|null}
   */
  const findVariant = (variantId) => {
    const product = window.smartfitProductData;

    if (!product || !Array.isArray(product.variants)) {
      return null;
    }

    return (
      product.variants.find(
        (variant) => String(variant.id) === String(variantId)
      ) || null
    );
  };

  /**
   * Update all Smartfit attributes when the Shopify variant changes.
   *
   * @param {Object} variant
   */
  const updateSmartfitWidget = (variant) => {
    const widget = getSmartfitWidget();
    const product = window.smartfitProductData;

    if (!widget || !variant || !product) {
      return;
    }

    if (variant.barcode) {
      widget.setAttribute("global-id", variant.barcode);
    } else {
      widget.removeAttribute("global-id");
    }

    widget.setAttribute("variant-id", String(variant.id));
    widget.setAttribute("name", product.title);
    widget.setAttribute(
      "price",
      (Number(variant.price) / 100).toFixed(2)
    );

    const variantImage =
      variant.featured_image?.src ||
      variant.featured_image ||
      product.featured_image;

    if (variantImage) {
      widget.setAttribute("image", variantImage);
    }
  };

  /**
   * Read the selected variant from the Shopify product form.
   */
  const syncFromProductForm = () => {
    const widget = getSmartfitWidget();

    if (!widget) {
      return;
    }

    const section =
      widget.closest(".shopify-section") ||
      widget.closest("product-info") ||
      document;

    const variantInput = section.querySelector(
      'form[action*="/cart/add"] [name="id"]'
    );

    if (!variantInput?.value) {
      return;
    }

    const variant = findVariant(variantInput.value);

    if (variant) {
      updateSmartfitWidget(variant);
    }
  };

  /**
   * Fallback for Shopify themes that update the variant after
   * a normal select, radio-button or swatch change.
   */
  document.addEventListener("change", (event) => {
    const productForm = event.target.closest(
      'form[action*="/cart/add"]'
    );

    if (!productForm) {
      return;
    }

    window.setTimeout(syncFromProductForm, 50);
  });

  /**
   * Support common Shopify theme variant events.
   */
  document.addEventListener("variant:change", (event) => {
    const variant = event.detail?.variant || event.detail;

    if (variant?.id) {
      updateSmartfitWidget(variant);
    } else {
      syncFromProductForm();
    }
  });

  document.addEventListener("product:variant-change", (event) => {
    const variant = event.detail?.variant || event.detail;

    if (variant?.id) {
      updateSmartfitWidget(variant);
    } else {
      syncFromProductForm();
    }
  });

  /**
   * Support themes based on Shopify Dawn's publish/subscribe system.
   */
  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined" &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;

      if (variant) {
        updateSmartfitWidget(variant);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", syncFromProductForm);
  document.addEventListener("shopify:section:load", syncFromProductForm);
})();